import { ActionTypes } from "./ActionTypes";
import { SideBarData } from "../../types/SideBarData";
import { Action, ActionCreator } from "redux";

export const setSideBarData: ActionCreator<Action> = (
    sideBarData: SideBarData
) => {
    return {
        type: ActionTypes.SET_SIDEBAR_DATA,
        sideBarData: sideBarData
    };
};
